import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "dynamic", "input" ]
  static values = {
    matcher: String
  }

  connect() {
    this.element[this.identifier] = this
    this.hiddenClass = this.data.get("class") || "hidden"
    this.#applyVisibility()
  }

  #applyVisibility() {
    if (!this.hasInputTarget) return

    const inputTarget = this.inputTarget

    this.dynamicTargets.forEach(target => {
      target.classList.add(this.hiddenClass)
    })

    let matchingTargets = this.dynamicTargets.filter(target => {
      let matcher = new RegExp(target.dataset.visibilityMatcherValue)
      return matcher.test(inputTarget.value)
    })

    matchingTargets.forEach(target => {
      target.classList.remove(this.hiddenClass)
    })
  }

  show(event) {
    event.preventDefault()

    const inputTarget = event.currentTarget

    if (inputTarget) {
      this.dynamicTargets.forEach( target => {
        target.classList.add(this.hiddenClass)
      })

      let matchingTargets = this.dynamicTargets.filter(target => {
        let matcher = new RegExp(target.dataset.visibilityMatcherValue)
        return matcher.test(inputTarget.value)
      })

      matchingTargets.forEach(target => {
        target.classList.remove(this.hiddenClass)
      })
    } else {
      this.dynamicTargets.forEach(target => {
        target.classList.remove(this.hiddenClass)
      })
    }
  }
}
